import { render, staticRenderFns } from "./Buy-old.vue?vue&type=template&id=19e08a2e&scoped=true"
import script from "./Buy-old.vue?vue&type=script&lang=js"
export * from "./Buy-old.vue?vue&type=script&lang=js"
import style0 from "./Buy-old.vue?vue&type=style&index=0&id=19e08a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e08a2e",
  null
  
)

export default component.exports